import React, {useState, useRef} from "react";
import { Link, useHistory } from "react-router-dom";
import AuthService from "../../../../service/auth.service";
import { Row, Col, Form, Input, Button, Checkbox, Alert } from "antd";
import LeftContent from "../leftContent";

export default function Login() {
  let history = useHistory();
  const form = useRef();
  const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState(false);
	//const [errorMsg, setErrorMsg] = useState(false);
  
	const onChangeusername = (e) => {
	  const usernamex = e.target.value.toLowerCase();
	  setEmail(usernamex);
	};
  
	const onChangePassword = (e) => {
	  const passwordx = e.target.value;
	  setPassword(passwordx);
	};
  
	const handleLogin = (e) => {
		AuthService.login(email, password).then(
		  () => {
        history.push("/dashboard-options");
        window.location.reload();
		  },
		  (error) => {
        const resMessage =
          (error.response &&
          error.response.data &&
          error.response.data.message) ||
          error.message ||
          error.toString();
        console.log(resMessage)
        if (error.response.status === 400){
          setErrorMsg(true)
        }
		  }
		);
	};


  return (
    <Row gutter={[32, 0]} className="hp-authentication-page">
      <LeftContent />

      <Col lg={12} span={24} className="hp-py-sm-0 hp-py-md-64">
        <Row className="hp-h-100" align="middle" justify="center">
          <Col
            xxl={11}
            xl={15}
            lg={20}
            md={20}
            sm={24}
            className="hp-px-sm-8 hp-pt-24 hp-pb-48"
          >
            <h1 className="hp-mb-sm-0">Login</h1>
            <p className="hp-mt-sm-0 hp-mt-8 hp-text-color-black-60">
              Welcome back, please login to your account.
            </p>
            { errorMsg ? 
                  <Alert message="Your email or password is incorrect. Please try again." type="error" /> 
									:
									undefined
								}
            <Form
              ref={form}
              onFinish={handleLogin}
              layout="vertical"
              name="basic"
              className="hp-mt-sm-16 hp-mt-32"
            >
              <Form.Item label="Username :" className="hp-mb-16">
                <Input id="error" name="email" value={email} onChange={onChangeusername}/>
              </Form.Item>

              <Form.Item label="Password :" className="hp-mb-8">
                <Input.Password id="warning2" name="password" value={password} onChange={onChangePassword}/>

              </Form.Item>

              <Form.Item className="hp-mt-16 hp-mb-8">
                  <Button type="submit" htmlType="submit" id="btn">
                    Sign in
                  </Button>
              </Form.Item>
            </Form>

            <Col className="hp-form-info">
              <span className="hp-text-color-black-80 hp-text-color-dark-40 hp-caption hp-mr-4">
                Don’t you have an account?
              </span>
              <Link
                to="registration"
                className="hp-text-color-primary-1 hp-text-color-dark-primary-2 hp-caption"
              >
                Register Now!
              </Link>
            </Col>
            <Col className="hp-form-info hp-mt-5">
                  <span className="hp-text-color-black-80 hp-text-color-dark-40 hp-caption hp-mr-4">
                    Forget Your Password?
                  </span>
                  <Link
                    to="pw-recover"
                    className="hp-text-color-danger-1 hp-text-color-dark-primary-2 hp-caption"
                  >
                    Reset it!
                  </Link>
            </Col>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};